import type { Observable as ObservableType } from 'rxjs/Observable';
import { transitionAndRankFetch } from '../../rest/cards-transition-and-rank/index.tsx';
import type { TransitionAndRankResponse } from '../../rest/cards-transition-and-rank/types.tsx';

export const transitionAndRankService = ({
	rankCustomFieldId,
	issueKeys,
	targetColumn,
	rankBeforeIssueIdOrKey,
	rankAfterIssueIdOrKey,
	rapidViewId,
	selectedTransitionId,
	calculateNewIssuesOrder = false,
}: {
	rankCustomFieldId: number;
	issueKeys: string[];
	targetColumn: number | null;
	rankBeforeIssueIdOrKey: string | null;
	rankAfterIssueIdOrKey: string | null;
	rapidViewId: number;
	selectedTransitionId?: number;
	calculateNewIssuesOrder?: boolean;
}): ObservableType<TransitionAndRankResponse> =>
	transitionAndRankFetch({
		rankCustomFieldId,
		issueKeys,
		targetColumn,
		rankBeforeIssueIdOrKey,
		rankAfterIssueIdOrKey,
		rapidViewId,
		selectedTransitionId,
		calculateNewIssuesOrder,
	});
